import ShariahScreeningMethodology from "../../UI/pages/ShariahScreeningMethodology";
import { publicPageHeaders } from "./publicPage.server";

// Server-rendered; title, description and canonical come from the root meta.
export const headers = publicPageHeaders;

export default ShariahScreeningMethodology;
